import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Bookmark or un-bookmark a message — the server creates / deletes
 * a row in the user's
 * `privateProfiles/{userId}/communityChannelBookmarks` collection.
 * Live "is bookmarked?" state comes from a separate Firestore
 * subscription on that collection.
 */
export async function toggleBookmarkMessage({
  creatorId,
  channelId,
  messageId,
  remove,
}: {
  creatorId: string;
  channelId: string;
  messageId: string;
  remove: boolean;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerToggleCommunityChannelMessageBookmark({
    sellerId: creatorId,
    channelId,
    messageId,
    ToggleCommunityChannelMessageBookmarkRequest: { remove },
  });
}
